import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Message } from '../../';

const { Fragment } = React;

const mapStateToProps = state => {
    return {
        messages: state.get('localization').get('messageProperties'),
        payoutState: state.get('payout').toJS(),
        config: state.get('config').toJS()
    };
};

@connect(mapStateToProps)
export default class W9 extends React.Component {
    static propTypes = {
        onDocSignClick: PropTypes.func,
        payoutState: PropTypes.object,
        config: PropTypes.object
    };

    render() {
        const { payoutState, config, onDocSignClick } = this.props;
        const { prizeAcceptanceFormAddressMap } = config;
        const { foreignTax, address } = payoutState.form;
        const country = address.country || 'EN';
        let prizeAcceptanceFormObj = prizeAcceptanceFormAddressMap.find(item => item.country === country);
        if (!prizeAcceptanceFormObj) {
            prizeAcceptanceFormObj = prizeAcceptanceFormAddressMap.find(item => item.country === 'EN');
        }
        const privacyPolicyAddress = prizeAcceptanceFormObj.address;
        return (
            <div>
                {!foreignTax ? (
                    <Fragment>
                        <h2 className="payout-title">
                            <Message code="epic.esport.label.w9Form" />
                        </h2>
                        <p>
                            <Message code="epic.esport.w9.form" />
                            <a onClick={onDocSignClick} className="form-link-w9" href={config.w9FormAddress} target="_blank">
                                {config.w9FormAddress}
                            </a>
                        </p>
                    </Fragment>
                ) : (
                    <Fragment>
                        <h2 className="payout-title">
                            <Message code="epic.esport.label.w8Form" />
                        </h2>
                        <p>
                            <Message code="epic.esport.w8.form" />
                            <a onClick={onDocSignClick} className="form-link-w9" href={privacyPolicyAddress} target="_blank">
                                {privacyPolicyAddress}
                            </a>
                        </p>
                    </Fragment>
                )}
            </div>
        );
    }
}
